import React from 'react';
import { Paper, Stack, TextField, MenuItem, InputAdornment } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faUserTie, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import 'moment/locale/es';

// Configuración global de idioma
moment.locale('es');

export default function BookingFilters({ 
    date, setDate, 
    filters, setFilters, 
    resources 
}) {
    
    const handleFilterChange = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: value }));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
            <Paper sx={{ p: 2, mb: 3, borderRadius: 3, boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems="center">
                    
                    {/* 1. DATE PICKER (Corregido para versión 5) */}
                    <DatePicker
                        label="Ir a fecha"
                        value={moment(date)}
                        onChange={(newValue) => {
                            setDate(newValue ? newValue.toDate() : new Date());
                        }}
                        // --- CAMBIO CLAVE AQUÍ ---
                        // En lugar de slotProps, usamos renderInput que es obligatorio en tu versión
                        renderInput={(params) => (
                            <TextField 
                                {...params} 
                                size="small" 
                                fullWidth
                                InputProps={{
                                    ...params.InputProps, // Mantiene el icono del calendario original
                                    startAdornment: (     // Agrega nuestro icono extra a la izquierda
                                        <InputAdornment position="start">
                                            <FontAwesomeIcon icon={faCalendarAlt} color="#666"/>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                    />

                    {/* 2. FILTRO EMPLEADO */}
                    <TextField
                        select
                        label="Filtrar por Recurso"
                        size="small"
                        fullWidth
                        value={filters.employee_id || ''}
                        onChange={(e) => handleFilterChange('employee_id', e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FontAwesomeIcon icon={faUserTie} color="#666"/>
                                </InputAdornment>
                            )
                        }}
                    >
                        <MenuItem value="">Todos los recursos</MenuItem>
                        {resources.map(res => (
                            <MenuItem key={res.id} value={res.id}>
                                {res.title}
                            </MenuItem>
                        ))}
                    </TextField>

                    {/* 3. FILTRO ESTATUS */}
                    <TextField
                        select
                        label="Estatus"
                        size="small"
                        fullWidth
                        value={filters.status || ''}
                        onChange={(e) => handleFilterChange('status', e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <FontAwesomeIcon icon={faFilter} color="#666"/>
                                </InputAdornment>
                            )
                        }}
                    >
                        <MenuItem value="">Todos los estatus</MenuItem>
                        <MenuItem value="pending">⚠️ Pendientes</MenuItem>
                        <MenuItem value="confirmed">✅ Confirmadas</MenuItem>
                        <MenuItem value="completed">🏁 Completadas</MenuItem>
                        <MenuItem value="cancelled">❌ Canceladas</MenuItem>
                    </TextField>

                </Stack>
            </Paper>
        </LocalizationProvider>
    );
}